import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import {
  fetchCountryList,
  fetchLanguageList,
  getLanguageDictionary,
} from 'reducers/utils';
import { getLoadingState } from 'reducers/ui';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Login from 'containers/Login';
import ProtectedRoute from 'containers/ProtectedRoute';
import RedirectedRoute from 'containers/ProtectedRoute/redirected';
import DashboardLayout from 'containers/DashboardLayout/DashboardLayout';
import RecoverPassword from 'containers/RecoverPassword';
import RecoverPasswordSuccess from 'containers/RecoverPassword/SuccessMessage';
import ResetPassword from 'containers/ResetPassword';
import PasswordResetSuccess from 'containers/ResetPassword/SuccessMessage';
import tokenInvalid from 'containers/ResetPassword/tokenInvalid';
import CreatePassword from 'containers/CreatePassword';
import PwdCreateSuccess from 'containers/CreatePassword/pwdCreateSuccess';
import ChangePassword from 'containers/ChangePassword';
import EmailVerify from 'containers/EmailVerify';
import SnackBar from 'components/Snackbar';
import { PAGE_URLS } from 'utils/constants';
import { Dashboard } from 'containers/Pages/Dashboard';
import { getSelectedTheme } from 'selectors/themeSelector';
import { Template } from 'containers/Pages/Tasks/Template';
import { Calendar } from 'containers/Pages/CalendarUI';
import CleanerTasks from 'containers/Pages/Tasks/CleanerTasks/cleanerTasks';
import Personnel from 'containers/Pages/People/Personnel/personnel';
import Zones from 'containers/Pages/Locations/Zones/zones';
import { BusinessClients } from 'containers/Pages/People/BusinessClients';
import { Customers } from 'containers/Pages/People/Customers';
import { AssetTypes } from 'containers/Pages/Assets/AssetTypes';
import { Assets } from 'containers/Pages/Assets/Assets';
import { PatrolTemplates } from 'containers/Pages/Tasks/PatrolTemplates';
import { Departments } from 'containers/Pages/People/Departments';
import { Events } from 'containers/Pages/Events';
import { Trips } from 'containers/Pages/Tasks/Trips';
import { TripTypes } from 'containers/Pages/Tasks/TripTypes';
import { Emergencies } from 'containers/Pages/Tasks/Emergencies';
import { Attendance } from 'containers/Pages/People/Attendance';
import { Visitors } from 'containers/Pages/Locations/Visitors';
import { Messages } from 'containers/Pages/Messages';
import { Sites } from 'containers/Pages/Locations/Sites';
import { Patrols } from 'containers/Pages/Tasks/Patrols';
import { TaskTypes } from 'containers/Pages/Tasks/TaskTypes';
import { WorkOrders } from 'containers/Pages/Tasks/WorkOrders';
import { PendingCompanies } from 'containers/Pages/Region/PendingCompany';
import { AccountPage } from 'containers/Pages/Admin/Account';
import PasswordCreateResetRoute from 'containers/ProtectedRoute/passwordCreateResetRoute';
import Securities from 'containers/Pages/Tasks/Security/securities';
import ParentWrapper from './parentWrapper';
import { VisitorTypes } from 'containers/Pages/Locations/VisitorTypes';
import { EventTypes } from 'containers/Pages/Admin/EventTypes';
import { Companies } from 'containers/Pages/Region/Companies';
import { Regions } from 'containers/Pages/Region/Region';

const AppRouter = ({
  fetchCountryList,
  fetchLanguageList,
  // loading,
  // languages,
}) => {
  const theme = useSelector(state => getSelectedTheme(state));

  const initialDataFetch = () => {
    fetchCountryList();
    fetchLanguageList();
  };
  useEffect(() => {
    initialDataFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Router>
      <MuiThemeProvider theme={theme}>
        <SnackBar />
        <div style={{ width: '100vw', height: '100vh' }}>
          <Switch>
            <RedirectedRoute exact={true} path="/" component={Login} />
            <RedirectedRoute path="/login" component={Login} />
            <RedirectedRoute
              path="/pwd-reset/success"
              component={PasswordResetSuccess}
            />
            <RedirectedRoute
              path="/pwd-reset/failure"
              component={tokenInvalid}
            />
            <RedirectedRoute path="/pwd-reset" component={ResetPassword} />
            <RedirectedRoute
              path="/pwd-recover/success"
              component={RecoverPasswordSuccess}
            />
            <RedirectedRoute path="/pwd-recover" component={RecoverPassword} />
            <RedirectedRoute path="/email-verify" component={EmailVerify} />
            <PasswordCreateResetRoute
              path="/pwd-create"
              component={CreatePassword}
            />
            <Route path="/create-pwd/success" component={PwdCreateSuccess} />
            <ProtectedRoute path="/change-pwd" component={ChangePassword} />
            <ParentWrapper>
              <DashboardLayout>
                <Switch>
                  <ProtectedRoute
                    path={PAGE_URLS.DASHBOARD.link}
                    component={Dashboard}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.CALENDAR.link}
                    component={Calendar}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.TEMPLATE_TASKS.link}
                    component={Template}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.TASK_TYPES.link}
                    component={TaskTypes}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.WORK_ORDERS.link}
                    component={WorkOrders}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.SECURITY_TASKS.link}
                    component={Securities}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.TEMPLATE_PATROLS.link}
                    component={PatrolTemplates}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.WORK_ORDERS.link}
                    component={WorkOrders}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.PATROLS.link}
                    component={Patrols}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.CLEANING_TASKS.link}
                    component={CleanerTasks}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.EMERGENCIES.link}
                    component={Emergencies}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.TRIPS.link}
                    component={Trips}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.TRIP_TYPES.link}
                    component={TripTypes}
                  />

                  <ProtectedRoute
                    path={PAGE_URLS.PERSONNEL.link}
                    component={Personnel}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.BUSINESS_CLIENTS.link}
                    component={BusinessClients}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.CUSTOMERS.link}
                    component={Customers}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.ATTENDANCE.link}
                    component={Attendance}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.ASSET_TYPES.link}
                    component={AssetTypes}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.ASSETS.link}
                    component={Assets}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.VISITORS.link}
                    component={Visitors}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.VISITOR_TYPES.link}
                    component={VisitorTypes}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.ACCOUNT.link}
                    component={AccountPage}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.DEPARTMENTS.link}
                    component={Departments}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.EVENTS.link}
                    component={Events}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.EVENT_TYPES.link}
                    component={EventTypes}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.REGION.link}
                    component={Regions}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.PENDING_COMPANY.link}
                    component={PendingCompanies}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.COMPANY.link}
                    component={Companies}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.SITES.link}
                    component={Sites}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.MESSAGES.link}
                    component={Messages}
                  />
                  <ProtectedRoute
                    path={PAGE_URLS.ZONES.link}
                    component={Zones}
                  />
                  <Redirect path="**" to="/" />
                </Switch>
              </DashboardLayout>
            </ParentWrapper>
          </Switch>
        </div>
      </MuiThemeProvider>
    </Router>
  );
};
AppRouter.propTypes = {
  languages: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchCountryList: PropTypes.func.isRequired,
  fetchLanguageList: PropTypes.func.isRequired,
};
const mapStateToProps = state => ({
  loading: getLoadingState(state),
  languages: getLanguageDictionary(state),
});
const mapDispatchToProps = dispatch => ({
  fetchCountryList: () => dispatch(fetchCountryList()),
  fetchLanguageList: () => dispatch(fetchLanguageList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter);
